let totalCount = 0;

export function loadHandler(isLoading, count) {
	console.log("loadings", isLoading, count);

	if (totalCount === 0 && isLoading) {
		window.vue.$Progress.start();
		document.body.classList.add("loading");
	}

	totalCount = totalCount + count;

	if (totalCount === 0) {
		document.body.classList.remove("loading");
		window.vue.$Progress.finish();
	}
}
